import "../header.css";

function Header() {
  return (
    <header className="header">
      <div className="header-inner">
        <div className="header-brand">
          <span className="header-icon">📚</span>
          <span className="header-logo">StudyForge</span>
        </div>
        <nav className="header-nav">
          <a href="#planner" className="nav-link">
            Planner
          </a>
          <a href="#tips" className="nav-link">
            Study Tips
          </a>
          <a href="#about" className="nav-link">
            About
          </a>
        </nav>
        <div className="header-badge">Free Tool</div>
      </div>
    </header>
  );
}

export default Header;
